import { postData } from "./commonServices";
import { LOGIN, REGISTER } from "../serviceUrls";

// Helper to get token from localStorage
const getToken = () => localStorage.getItem("access_token");

// Authentication API Service
export const authAPI = {
  // Login user
  login: async (credentials) => {
    const response = await postData(LOGIN, credentials);

    // Store token in localStorage if login successful
    if (response.access_token) {
      localStorage.setItem("access_token", response.access_token);
      localStorage.setItem("user", JSON.stringify(response.user));
    }

    return response;
  },

  // Register new user
  register: async (userData) => {
    return await postData(REGISTER, userData);
  },

  // Logout user
  logout: () => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("user");
    return Promise.resolve();
  },

  // Get current user from localStorage
  getCurrentUser: () => {
    const user = localStorage.getItem("user");
    return user ? JSON.parse(user) : null;
  },

  // Check if user is authenticated
  isAuthenticated: () => {
    return !!localStorage.getItem("access_token");
  },

  // Get stored token
  getToken: () => {
    return localStorage.getItem("access_token");
  },
};
